import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { websitePrivacyNotice } from '../../content/website-privacy';
import '../../analytics/analytics.css';

export default function Privacy() {
  useEffect(() => {
    document.getElementById('main')?.focus({ preventScroll: true });
  }, []);

  return (
    <main id="main" tabIndex={-1} className="kds-website-privacy kds-stack">
      <Helmet>
        <title>Website privacy · Keval Langalia</title>
        <meta name="description" content="How keval.io uses optional analytics, cookies and browser storage, and how to change your analytics choice." />
        <link rel="canonical" href="https://keval.io/privacy" />
      </Helmet>
      <header className="kds-stack">
        <Link to="/" className="kds-link">Back to Keval's portfolio</Link>
        <p className="kds-eyebrow">keval.io · Privacy</p>
        <h1 className="kds-headline-lg">Website privacy</h1>
        <p>{websitePrivacyNotice.standaloneIntro}</p>
        <p>
          Looking for mobile app privacy? View the{' '}
          <Link to="/apps/birdify/privacy" className="kds-link">
            Birdify app privacy policy
          </Link>.
        </p>
        <p>Privacy contact: <a href="mailto:hello@keval.io">hello@keval.io</a></p>
      </header>
      {websitePrivacyNotice.pending.length > 0 ? (
        <aside className="kds-callout" role="note">
          <h2 className="kds-title-md">Pre-publication draft</h2>
          <ul>
            {websitePrivacyNotice.pending.map((item) => <li key={item.id}>{item.label}</li>)}
          </ul>
        </aside>
      ) : null}
      {websitePrivacyNotice.sections.map((section) => (
        <section key={section.id} className="kds-prose" aria-labelledby={section.id}>
          <h2 id={section.id} className="kds-title-lg">{section.heading}</h2>
          {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {section.links ? (
            <ul>
              {section.links.map((link) => (
                <li key={link.href}>
                  <a href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a>
                </li>
              ))}
            </ul>
          ) : null}
        </section>
      ))}
    </main>
  );
}
